// @ts-ignore
import Cookies, {CookieAttributes} from 'js-cookie'
import {LoginResponseType} from "@/utils/general.type";

const COOKIE_CREDENTIAL = "z";
const COOKIE_CLUB = "club";

// type CredentialType = {
//     [COOKIE_CREDENTIAL]: string,
//     [COOKIE_CLUB]: number,
// }

const defaultOptions: CookieAttributes = {
    expires: 7,
    path: '/',
    sameSite: 'strict',
};

export const setLoginCookie = (response: LoginResponseType) => {
    // const newObject: CredentialType = {
    //     [COOKIE_CLUB]: club,
    //     [COOKIE_CREDENTIAL]: key,
    // };

    const cookieKey = getLoginCookie();
    if (cookieKey.length > 0) {
        const index = cookieKey.findIndex((c: LoginResponseType) =>
            c.MemberClub === response.MemberClub
        );
        if (index > -1) {
            cookieKey[index] = response;
            setCookie(COOKIE_CREDENTIAL, JSON.stringify(cookieKey));
            return;
        }
    }
    cookieKey.push(response);
    setCookie(COOKIE_CREDENTIAL, JSON.stringify(cookieKey));
}

export const removeLoginCookie = () => {
    setCookie(COOKIE_CREDENTIAL, undefined);
}

export const getLoginCookie = (): LoginResponseType[] => {
    // return [{"MemberClub":2,"MemberNo":"TV1089443","SessionKey":"2203211349135876V3CRJ777TXYBTBVS3NENBRAN26DUKRUAJUJCDDITDK3P79EYSB"},{"MemberClub":3,"MemberNo":"TB1017787","SessionKey":"22032113491435384CM8XBEXUZBN9YSPVDPCUREP27LRHNTMKFRWSUZUAQI3DINS9Z"},{"MemberClub":6,"MemberNo":"TT1000114","SessionKey":"2203211349149319IJE6DJ6GWBRSAKTNQXEL5739JQLKZ8YL4XTTS3KSKR5BYYSPMV"}];
    try {
        return JSON.parse(getCookie(COOKIE_CREDENTIAL) ?? '[]') as LoginResponseType[];
    } catch (e) {
        return [] as LoginResponseType[];
    }
}

const setCookie = (name: string, value: string | undefined) => {
    if (value === undefined) {
        Cookies.remove(name, defaultOptions);
    } else {
        Cookies.set(name, value, defaultOptions);
    }
}

const getCookie = (name: string): string | undefined => {
    return Cookies.get(name);
}
